"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePositions = exports.calculatePosition = void 0;
var lodash_1 = __importDefault(require("lodash"));
var calculatePosition = function (score, index, scores) {
    var positionIndex = index;
    var equalPosition = index < scores.length ? scores[index + 1] === score : false;
    while (positionIndex > 0 && scores[positionIndex - 1] === score) {
        positionIndex -= 1;
        equalPosition = true;
    }
    return { position: positionIndex + 1, equalPosition: equalPosition };
};
exports.calculatePosition = calculatePosition;
var calculatePositions = function (input) {
    var sortedInput = lodash_1.default.chain(input)
        .map(function (score, id) { return ({ id: id, score: score }); })
        .sortBy(function (i) { return i.score; })
        .reverse()
        .value();
    var scores = sortedInput.map(function (v) { return v.score; });
    return sortedInput.map(function (p, index) {
        var _a = exports.calculatePosition(p.score, index, scores), position = _a.position, equalPosition = _a.equalPosition;
        return {
            id: p.id,
            position: {
                position: position,
                equalPosition: equalPosition,
                score: p.score,
            },
        };
    });
};
exports.calculatePositions = calculatePositions;
//# sourceMappingURL=calculatePositions.js.map